var Giant = Giant || {};

;(function($, window, document, undefined) {

    var pluginName = 'giantSwitcher',
        dataPrefix = 'switcher',
        $window = $(window),
        defaults = {

        };

    function Switcher(element, options) {
        this.scope = element;
        this.$scope = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Switcher.prototype = {

        init: function() {
            var self = this;

            this.attach();

            return this;
        },

        attach: function() {
            var self = this,
                checked = this.$scope.prop('checked');

            var $wrap = $('<div class="switcher__wrap"></div>');
            this.$scope.wrap($wrap);
            this.$scope.after('<div class="switcher' + (checked ? ' switcher--checked' : '') + '"><span class="switcher__text">' + (checked ? 'Ano' : 'Ne') + '</span><div class="switcher__knob"></div></div>');

            this.$scope.parent().find('.switcher').on('click', function(event) {
                var $input = $(this).prev('input'),
                    checked = $(this).prev('input').prop('checked'),
                    $text = $(this).find('.switcher__text');

                $(this).toggleClass('switcher--checked');

                if (checked) {
                    $input.prop('checked', false).trigger('change');
                    $text.text('Ne');
                } else {
                    $input.prop('checked', true).trigger('change');
                    $text.text('Ano');
                }
            });
        },

        detach: function() {
            // this.$scope.off('');
        }

    };

    $.fn[pluginName] = function (options) {
        var dataPrefixLength = dataPrefix.length;

        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {

                // parse data-options
                var data = $(this).data(),
                    options = {},
                    settings = '';

                if (pluginName in data) {
                    settings = data[pluginName];
                    // pass options
                    if ($.type(settings) === 'object') {
                        options = settings;
                    }
                }

                // pass all options to plugin
                $.each(data, function(key, value) {
                    if (key.substr(0, dataPrefixLength) === dataPrefix && key !== dataPrefix) {
                        var id = key.substr(dataPrefixLength);
                        id = id.substr(0,1).toLowerCase() + id.substr(1);
                        options[id] = value;
                    }
                });

                $.data(this, 'plugin-' + pluginName, new Switcher(this, options));
            }
        });
    };

    $.fn[pluginName].defaults = defaults;

    // listen to change event and init self
    $(document).on('dom:change', function(event) {
        $('[data-switcher]', event.target).giantSwitcher();
    });
    $('[data-switcher]').giantSwitcher();

    Giant.Switcher = Switcher;

})(jQuery, window, document);